<div class="container-fluid mt-3 p-2">
  <div class="row">
    <div class="col-md-12 col-lg-4 m-b">
      <div class="card-1">
        <div class="row">
          <div class="col-sm-6 col-lg-12 profile-info-left">
            <div class="profile-header">
              <div class="profile-pic">
                <upload [formControl]="avatarImageFormControl" [disableRemove]="true" [max]="1024 * 11000"
                  allowedTypes="jpg,jpeg,png" (uploadError)="setUploadError($event)" [circledImg]="true"></upload>
                <span class="file-info-tooltip" aria-label="Upload file info">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  <span class="tooltip-text">
                    {{ 'profile.max_size' | translate }}<br />
                    {{ 'profile.file_types' | translate }}
                  </span>
                </span>
                <div class="profile-image-alert" [hidden]="!avatarImageChanged">
                  <div class="alert alert-success text-start" role="alert">{{ 'profile.profile_image_updated' |
                    translate }}</div>
                </div>
                <div class="profile-image-errors">
                  <errors [on]="uploadError">
                    <span [hidden]="uploadError !== 'invalid-size'">{{ 'profile.file_size_error' | translate }}</span>
                    <span [hidden]="uploadError !== 'invalid-file-type'">{{ 'profile.file_type_error' | translate
                      }}</span>
                  </errors>
                </div>
              </div>

              <div class="profile-meta">
                <div class="profile-name text-capitalize">
                  {{ currentUser?.firstName && currentUser?.firstName }}
                  {{ currentUser?.lastName && currentUser?.lastName }}
                </div>
                <div class="profile-since">
                  <span class="since-text">{{ 'profile.since' | translate }} {{ getProfileYear() }}</span>
                </div>
                <div class="account-type">
                  {{ (currentUser?.brn && ('profile.corporate' | translate)) || ('profile.individual' | translate) }}
                </div>

                <div class="profile-info">
                  <span class="user-id">{{ currentUser?.nic || currentUser?.passport }}</span>
                </div>

              </div>
            </div>

            <div class="personal-information-section">
              <h2 class="section-title">{{ 'profile.personal_information' | translate }}</h2>

              <div class="personal-info-cards">
                <div class="info-card">
                  <div class="info-card-icon">
                    <i class="fa fa-user"></i>
                  </div>
                  <div class="info-card-content">
                    <label class="info-card-label">{{ 'profile.full_name' | translate }}</label>
                    <p class="info-card-value text-capitalize">
                      {{ (currentUser?.firstName && currentUser?.firstName) || '' }}
                      {{ (currentUser?.lastName && currentUser?.lastName) || '' }}
                    </p>
                  </div>
                </div>

                <div class="info-card">
                  <div class="info-card-icon">
                    <i class="fa fa-envelope"></i>
                  </div>
                  <div class="info-card-content">
                    <label class="info-card-label">{{ 'profile.email_address' | translate }}</label>
                    <p class="info-card-value">{{ currentUser?.email || 'N/A' }}</p>
                  </div>
                </div>

                <div class="info-card">
                  <div class="info-card-icon">
                    <i class="fa fa-phone"></i>
                  </div>
                  <div class="info-card-content">
                    <label class="info-card-label">{{ 'profile.mobile_number' | translate }}</label>
                    <p class="info-card-value">
                      {{
                      ((currentUser?.mobilePhoneCountryCode && currentUser?.mobilePhoneCountryCode) || '+94') +
                      ' ' +
                      ((currentUser?.mobilePhoneAreaCode && currentUser?.mobilePhoneAreaCode) || '') +
                      ' ' +
                      ((currentUser?.mobilePhoneNumber && currentUser?.mobilePhoneNumber) || 'N/A')
                      }}
                    </p>
                  </div>
                </div>

                <div class="info-card">
                  <div class="info-card-icon">
                    <i class="fa fa-building"></i>
                  </div>
                  <div class="info-card-content">
                    <label class="info-card-label">{{ 'profile.account_type' | translate }}</label>
                    <p class="info-card-value">{{ (currentUser?.brn && ('profile.corporate' | translate)) ||
                      ('profile.individual' | translate) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-8">
      <div class="tabs p-2">
        <div (click)="activeTab('edit-profile')" [ngClass]="activadedTab === 'edit-profile' ? 'active' : ''">
          {{ 'profile.edit_profile' | translate }}
        </div>

        <div (click)="activeTab('change-password')" [ngClass]="activadedTab === 'change-password' ? 'active' : ''">
          {{ 'profile.change_password' | translate }}
        </div>
      </div>
      <div class="card-1">
        <div class="profile-container">
          <div class="edit-profile" [hidden]="activadedTab !== 'profile' && activadedTab !== 'edit-profile'">
            <h4 (click)="collapse('name')">
              {{ 'profile.edit_name' | translate }} <i class="fa"
                [ngClass]="collapseibleTab === 'name' ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
            <form *ngIf="customerProfileFG && collapseibleTab === 'name'" #form="ngForm" [formGroup]="customerProfileFG"
              (ngSubmit)="customerProfile(form)" class="form profile-edit" novalidate>
              <div class="form-group" [hidden]="!customerProfileSuccessMsg">
                <div class="alert alert-success" role="alert">{{ 'profile.profile_updated_successfully' | translate }}
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="firstName">{{ 'profile.first_name' | translate }}</label>
                  <form-text [disabled]="activadedTab === 'profile'" [control]="customerProfileFG.get('firstName')"
                    label="" [placeholder]="'profile.first_name_placeholder' | translate" [maxLength]="40"
                    [showErrors]="form.submitted">
                    <span [hidden]="!customerProfileFG?.get('firstName')?.errors?.required">{{
                      'profile.first_name_required' | translate }}</span>
                  </form-text>
                </div>

                <div class="col-sm-6">
                  <label for="lastName">{{ 'profile.last_name' | translate }}</label>
                  <form-text [control]="customerProfileFG?.get('lastName')" [disabled]="activadedTab === 'profile'"
                    [placeholder]="'profile.last_name_placeholder' | translate" [maxLength]="40"
                    [showErrors]="form.submitted">
                    <span [hidden]="!customerProfileFG?.get('lastName')?.errors?.required">{{
                      'profile.last_name_required'
                      | translate }}</span>
                  </form-text>
                </div>
                <div class="col-6">
                  <div class="attachment-holder form-group" [hidden]="!sendAttachment">
                    <label class="note">{{ 'profile.changed_last_name' | translate }}
                      {{ (customerProfileFG?.controls['nic']?.value && ('profile.nic' | translate)) ||
                      ('profile.passport' | translate) }} {{ 'profile.image_for_verification' | translate }}</label>
                    <div class="row">
                      <div class="col-md-4 col-sm-12">
                        <upload formControlName="attachmentUrl" [checkEncripted]="true" [disableRemove]="false"
                          [max]="1024 * 10240 * 2" allowedTypes="jpg,jpeg,png,pdf"
                          (uploadError)="setAttachmentUploadError($event)" tabindex="7"></upload>
                      </div>
                      <div class="col-md-8 col-sm-12 align-self-end">
                        <p class="text-muted">{{ 'profile.max_size_20mb' | translate }} <br />{{ 'profile.file_types' |
                          translate }}</p>
                      </div>
                    </div>
                    <errors [on]="attchmentUploadError">
                      <span [hidden]="attchmentUploadError !== 'encripted'">{{ 'profile.file_password_protected' |
                        translate }}</span>
                      <span [hidden]="attchmentUploadError !== 'invalid-size'">{{ 'profile.file_size_20mb_error' |
                        translate }}</span>
                      <span [hidden]="attchmentUploadError !== 'invalid-file-type'">{{ 'profile.file_formats_allowed' |
                        translate }}</span>
                    </errors>
                    <div [hidden]="
                        customerProfileFG?.controls['attachmentUrl']?.valid ||
                        (!form.submitted && !customerProfileFG?.controls['attachmentUrl']?.touched)
                      " class="alert alert-danger">
                      <span [hidden]="!customerProfileFG?.controls['attachmentUrl']?.errors?.requireIfTrue">{{
                        'profile.please_upload_attachment' | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-left" [hidden]="activadedTab === 'profile'">
                <button [loading]="customerProfileInProgress" type="submit" class="btn-shadow btn-md btn btn-fill">{{
                  'profile.update' | translate }}</button>
              </div>
            </form>
            <p></p>
            <hr />
            <h4 (click)="collapse('mobile')">
              {{ 'profile.edit_mobile' | translate }} <i class="fa"
                [ngClass]="collapseibleTab === 'mobile' ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>

            <div class="change-mobile">
              <form *ngIf="changeMobileFG && collapseibleTab === 'mobile'" class="form user-form v-row" #mForm="ngForm"
                [formGroup]="changeMobileFG" (ngSubmit)="changeMobile(mForm)" novalidate>
                <div class="inner-fields p-0">
                  <div class="form-group col-sm-12 p-0">
                    <div class="form-errors alert alert-danger"
                      [hidden]="!verifySignupErrors || !verifySignupErrors.length">
                      <ul>
                        <li class="text-left" *ngFor="let error of verifySignupErrors">
                          {{ error }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-group col-sm-12" [hidden]="!verifyMobileSuccessMsg">
                    <div class="alert alert-success" role="alert">{{ 'profile.mobile_changed_successfully' | translate
                      }}
                    </div>
                  </div>
                  <div class="form-group clearfix">
                    <div class="row">
                      <div class="col-sm-6">
                        <label>{{ 'profile.current_mobile' | translate }}</label>
                        <label class="form-control">
                          {{
                          currentUser?.formattedMobileNumber || ''
                          }}</label>
                      </div>

                      <div class="col-sm-6">
                        <form-mobile-no [controls]="[
                            changeMobileFG.get('mobilePhoneCountryCode'),
                            changeMobileFG.get('mobilePhoneAreaCode'),
                            changeMobileFG.get('mobilePhoneNumber')
                          ]" [label]="'profile.new_mobile' | translate"
                          [placeholder]="'profile.mobile_placeholder' | translate" help=""
                          [showErrors]="mForm.submitted">
                          <span [hidden]="!changeMobileFG?.get('mobilePhoneAreaCode')?.errors?.required"> {{
                            'profile.number_required' | translate }}
                          </span>
                          <span [hidden]="
                              !changeMobileFG?.get('mobilePhoneNumber')?.errors?.requireIfTrue &&
                              !changeMobileFG?.get('mobilePhoneNumber')?.errors?.pattern
                            ">
                            {{ 'profile.invalid_number' | translate }}
                          </span>
                        </form-mobile-no>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" *ngIf="!changeMobileFG?.get('sentVerification')?.value">
                    <button [loading]="changeMobileInProgress" class="btn-shadow btn-md btn btn-fill"
                      (click)="sendMobileVerificationCode()" type="button">
                      {{ 'profile.update' | translate }}
                    </button>
                  </div>
                  <p [slide]="changeMobileFG?.get('sentVerification')?.value" class="form-group">
                    {{ 'profile.if_no_code' | translate }}
                  </p>
                </div>
                <div *ngIf="changeMobileFG?.get('sentVerification')?.value">
                  <div class="row col-sm-12 col-md-12">
                    <div class="form-group col-sm-9 col-md-8 col-lg-6">
                      <input formControlName="verificationCode" type="text" class="form-control col-sm-12"
                        [placeholder]="'profile.verification_code_placeholder' | translate" tabindex="2" />
                    </div>
                    <div class="form-group col-sm-3 col-md-4 col-lg-4 p-0 no-gutters">
                      <button [loading]="verifyingCodeInProgress" type="submit"
                        class="btn-shadow btn-md btn btn-fill">{{ 'profile.verify' | translate }}</button>
                    </div>
                  </div>
                  <div class="row col-md-12">
                    <div class="form-group col-sm-12 col-lg-9 float-left">
                      <div
                        [hidden]="changeMobileFG.controls['verificationCode'].valid || !mForm?.submitted || verifyMobileSuccessMsg"
                        class="alert alert-danger">
                        <span [hidden]="!changeMobileFG.controls.verificationCode.errors?.required">{{
                          'profile.verification_required' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <hr />
          </div>

          <div class="change-password" [hidden]="activadedTab !== 'change-password'">
            <form *ngIf="changePasswordFG" class="form user-form v-row" #pwform="ngForm" [formGroup]="changePasswordFG"
              (ngSubmit)="changePassword(pwform)" novalidate>
              <div class="inner-fields p-0">
                <div class="form-errors alert alert-danger"
                  [hidden]="!changePasswordErrors || !changePasswordErrors.length">
                  <ul>
                    <li class="text-left" *ngFor="let error of changePasswordErrors">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div class="form-group m-t-lg">
                  <div class="form-group row">
                    <div class="col-sm-6">
                      <label>{{ 'profile.current_password' | translate }}</label>
                      <input formControlName="currentPassword" type="password" class="form-control"
                        [placeholder]="'profile.your_password' | translate" tabindex="7" />
                      <div [hidden]="changePasswordFG.controls['currentPassword'].valid || !pwform.submitted"
                        class="alert alert-danger">
                        <span [hidden]="!changePasswordFG.controls.currentPassword.errors?.required">{{
                          'profile.required' | translate }}</span>
                        <span [hidden]="!changePasswordFG.controls.currentPassword.errors?.password">{{
                          changePasswordFG.controls['currentPassword'].errors?.password
                          }}</span>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <label>
                        {{ 'profile.new_password' | translate }}
                        <span class="password-help-tooltip" aria-label="Password requirements">
                          <i class="fa fa-info-circle" aria-hidden="true"></i>
                          <span class="tooltip-text">
                            {{ 'profile.password_requirements' | translate }}
                          </span>
                        </span>
                      </label>
                      <input formControlName="newPassword" type="password" class="form-control"
                        [placeholder]="'profile.your_password' | translate" tabindex="8" />

                      <div>
                        <span [hidden]="!changePasswordFG.controls.newPassword.errors?.required || !pwform.submitted"
                          class="alert alert-danger">{{ 'profile.required' | translate }}</span>
                        <span [hidden]="!changePasswordFG.controls.newPassword.errors?.password"
                          class="alert alert-danger">{{
                          changePasswordFG.controls['newPassword'].errors?.password
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-6">
                      <label>{{ 'profile.confirm_password' | translate }}</label>
                      <input formControlName="confirmPassword" type="password" class="form-control"
                        [placeholder]="'profile.retype_new_password' | translate" tabindex="9" />
                      <div *ngIf="
                          changePasswordFG.controls['confirmPassword'].invalid &&
                          (pwform.submitted || changePasswordFG.controls['confirmPassword'].touched)
                        " class="alert alert-danger">
                        <span [hidden]="!changePasswordFG.controls.confirmPassword.errors?.required">{{
                          'profile.please_retype_password' | translate }}</span>
                      </div>
                      <div *ngIf="changePasswordFG.errors" class="alert alert-danger">
                        <span [hidden]="!changePasswordFG.errors?.misMatchPasswords">{{ 'profile.passwords_dont_match' |
                          translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group clearfix">
                    <button [loading]="changePasswordInProgress" type="submit" class="btn-shadow btn-md btn btn-fill">
                      {{ 'profile.change_passoword' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- <div class="statement-settings" [hidden]="activadedTab !== 'statement-settings'"><app-settings></app-settings>
          </div> -->
          <!-- <div class="kyc-attachments" [hidden]="activadedTab !== 'kyc-attachments'">KYC Attachment</div> -->
        </div>
      </div>
    </div>
  </div>
</div>